
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payouts",
      function () {
        return require("private-next-pages/payouts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payouts"])
      });
    }
  